import classNames from 'classnames';
export default function CheckIcon({ size = 24, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('fill-current', className, color)}>
      <path fillRule="evenodd" d="M13.145 4.535a.667.667 0 0 1-.014.943l-6.184 6a.667.667 0 0 1-.928 0l-3.15-3.055a.667.667 0 1 1 .929-.957l2.685 2.605 5.72-5.55a.667.667 0 0 1 .942.014Z" clipRule="evenodd"/>
    </svg>);
}
